import React, { useEffect, useState } from "react";
import CinemaIcon from "./CinemaIcon";

export default function ChannelLogo({ channel }) {
  const logo =
    channel.SecondaryLogoImageUrl || channel.SecondaryLogoUrl || channel.logo;
  const [failed, setFailed] = useState([]);
  useEffect(() => setFailed([]), [logo, channel.logo]);
  const source = [logo, channel.logo].find(
    (url) => url && !failed.includes(url)
  );
  return (
    <span className="cinema-channel-logo" aria-hidden="true">
      {source ? (
        <img
          key={source}
          src={source}
          alt=""
          loading="lazy"
          decoding="async"
          draggable="false"
          onError={() => setFailed((urls) => [...urls, source])}
        />
      ) : (
        <CinemaIcon name="tv" />
      )}
    </span>
  );
}
